<script lang="ts">
  import { page } from "$app/stores";
  import { cn } from "$lib/utils";

  export let tabs: { name: string; href: string }[] = [];
</script>

<ul class="flex items-center gap-6">
  {#each tabs as tab}
    {@const isActive = tab.href === $page.url.pathname}
    <li>
      <a
        href={tab.href}
        class={cn(
          "border-b-2 border-transparent py-2 uppercase text-blog-gray-600",
          isActive && "border-blog-green-bright text-blog-gray-1000 dark:text-blog-gray-300",
        )}
      >
        {tab.name}
      </a>
    </li>
  {/each}
</ul>
